////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import _, { isEqual } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Button from '../../../../components/Ui/Buttons'
import Modals from '../../../../components/Modals'
import theme from '../../../../theme/theme'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalDeleteAddStartWithDepositWrapper = styled.div``
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalCustom = styled.div`
	padding: 0;
`
/////////STYLED/////////
// [63]_h): DELETE ADD START DEPOSIT

const ModalDeleteAddStartWithDeposit = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeleteAddStartWithDeposit = () => {
		actionsArticleLifeManager.postDeleteAddStartWithDeposit(props.deleteAddStartWithDeposit.item.header.id)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.deleteAddStartWithDeposit.close()
	}, [articleLifeManager?.isUpdate])

	const article = `<span style="color: ${theme.colors.primary}" > [${props?.deleteAddStartWithDeposit?.item?.header?.itemRefLabel}] </span>`
	const date = `<span style="color: ${theme.colors.primary}" > ${moment(
		props?.deleteAddStartWithDeposit?.currentDateAddStartWithDeposit?.dateToModify
	).format('DD/MM/YYYY')} </span>`
	let text = StringFormatter.ResponseMessageParser(
		_.replace(translations['modal__itemRef__timeline_action_consignment_startDate_delete_message'], '\\n', '<br>'),
		[article, date]
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalDeleteAddStartWithDepositWrapper>
			<Modals
				showModal={props?.deleteAddStartWithDeposit?.show}
				closeModalHandler={props?.deleteAddStartWithDeposit?.close}
				level="error"
				icon={true}
				title={translations['page__itemRef__timeline_action_consignment_startDate_delete']}
				width={555}
			>
				{translations && !isEqual(props?.deleteAddStartWithDeposit?.item?.header, {}) && (
					<TextTopWrapper>
						<TextModalWrapper>{<TextModalCustom dangerouslySetInnerHTML={{ __html: text }} />}</TextModalWrapper>
					</TextTopWrapper>
				)}

				<ButtonWrapper>
					<Button
						actionHandler={props?.deleteAddStartWithDeposit?.close}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleDeleteAddStartWithDeposit()}
						text={translations['modal__itemRef__timeline_action_consignment_startDate_delete_buttons_validate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
		</ModalDeleteAddStartWithDepositWrapper>
	)
}

ModalDeleteAddStartWithDeposit.propTypes = {}

ModalDeleteAddStartWithDeposit.defaultPropTypes = {}

export default ModalDeleteAddStartWithDeposit
